import React, { FunctionComponent, useEffect, useState } from "react";
import { Box, DialogContent, Toolbar } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { AlertDialog } from "../../AlertDialog";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { IAlbum, useGetAlbum } from "../../../hooks/albums";
import { AlbumLocationListSection } from "../../albums/AlbumLocationListSection";
import { StatusCodesHelper } from "../../../models/StatusCodesHelper";
import { IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { PiperDialog } from "../../PiperDialog";
import { IconType } from "../../../icons/IconType";

export const SelectAlbumLocationDialog: FunctionComponent<ISelectAlbumLocationDialogProps> = ({
  open,
  setOpen,
  album,
  callback
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertIsOpen, setAlertIsOpen] = useState(false);
  const [myAlbum, setMyAlbum] = useState(album);
  const { getAlbum } = useGetAlbum();
  const fetchAlbum = async () => {
    setIsLoading(true);
    const { status, body } = await getAlbum(album.uuid);
    if (StatusCodesHelper.isSuccessful(status)) {
      setMyAlbum(body);
    } else {
      setAlertMessage(body.message);
      setAlertIsOpen(true);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    if (open && album) {
      setMyAlbum(undefined);
      fetchAlbum().then();
    }
  }, [open]);
  return (
    <PiperDialog fullWidth maxWidth={"sm"} open={open} onClose={() => setOpen(false)}>
      <Toolbar>
        <h3>{strings.open_on_layout}</h3>
        <Box sx={{ flexGrow: 1 }} />
        <ToolbarButton
          loading={isLoading}
          onClick={() => setOpen(false)}
          tooltip={strings.close}
          iconType={IconType.Close}
        />
      </Toolbar>
      <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <AlbumLocationListSection
          hideHeader
          album={myAlbum}
          onBoxSetSelected={undefined}
          onLocationSelected={shelfSegmentAlbum => {
            setOpen(false);
            callback(shelfSegmentAlbum);
          }}
        />
      </DialogContent>
      <AlertDialog message={alertMessage} open={alertIsOpen} setOpen={setAlertIsOpen} />
    </PiperDialog>
  );
};

export interface ISelectAlbumLocationDialogProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  album?: IAlbum;
  callback?: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
}
